module.exports = __webpack_public_path__ + "media/images/app/footer/fb-circle-fe98d75e392bf238993751493ea3ae18.webp";